import PropTypes from 'prop-types';

import { Button } from '@mui/material';

import GenericFormContainer from '../Forms/GenericFormContainer';

import {
  lengthValidation50,
  lengthValidation200,
  maxFileSize,
  required,
} from '../Forms/utils';

import {
  CHECKBOX,
  EXPANDABLE_IMAGE_COMPONENT,
  IMAGE_UPLOAD,
  STYLED_TEXT,
} from '../Forms/fieldTypes';

const RemoteDoormanPopUpComponent = (props) => {
  const { form, onSubmit, initialValues, isUpdate, onDeletePopUp } = props;
  const { photo } = initialValues;
  const { url: imageSrc } = photo || {};
  const formData = [
    {
      keyName: 'headline',
      label: 'Headline text ',
      fieldType: STYLED_TEXT,
      validate: [required, lengthValidation50],
    },
    {
      keyName: 'body',
      label: 'Body text',
      fieldType: STYLED_TEXT,
      multiline: true,
      validate: [required, lengthValidation200],
    },
    {
      keyName: 'icon',
      label: 'icon',
      fieldType: EXPANDABLE_IMAGE_COMPONENT,
      src: imageSrc,
      height: '10rem',
      isHidden: !imageSrc,
    },
    {
      keyName: 'image',
      label: 'Image',
      fieldType: IMAGE_UPLOAD,
      validate: [maxFileSize],
      disabled: false,
    },
    {
      label: 'Delete image',
      keyName: 'isDeleteImage',
      fieldType: CHECKBOX,
      validate: [],
      isHidden: !imageSrc,
    },
  ];

  const DeletePopUpButton = () =>
    isUpdate ? (
      <Button
        variant="contained"
        color="secondary"
        disableElevation
        onClick={onDeletePopUp}
      >
        Delete Pop up
      </Button>
    ) : null;

  return (
    <GenericFormContainer
      form={form}
      formData={formData}
      onSubmit={onSubmit}
      initialValues={initialValues}
      title={`${isUpdate ? 'Update' : 'Create'} Pop up`}
      backButton={false}
      CustomComponent={DeletePopUpButton}
      isFullWidthForm
    />
  );
};

RemoteDoormanPopUpComponent.propTypes = {
  form: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  isUpdate: PropTypes.bool.isRequired,
  onDeletePopUp: PropTypes.func.isRequired,
};

export default RemoteDoormanPopUpComponent;
